import { memo } from 'react';
import DailyGift from '../components/DailyGift/DailyGift';

function DailyGiftBottomSheet() {
  return <DailyGift />;
}

export default memo(DailyGiftBottomSheet);
